var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1462 -246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1462 246)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1487 271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.585,45.825l4.74-.743V36.241l-4.74-.743a4.794,4.794,0,0,1-2.222-8.331l3.577-2.946-4.4-7.621-4.378,1.639a4.766,4.766,0,0,1-6.076-6.075l1.639-4.377L57.1,3.385,54.157,6.962A4.794,4.794,0,0,1,45.826,4.74L45.083,0H36.242L35.5,4.74a4.794,4.794,0,0,1-8.331,2.222L24.221,3.385,16.6,7.786l1.639,4.377a4.766,4.766,0,0,1-6.076,6.075L7.786,16.6l-4.4,7.621,3.577,2.946a4.654,4.654,0,0,1,1.511,4.8A4.705,4.705,0,0,1,4.74,35.5L0,36.241v8.841l4.74.743a4.649,4.649,0,0,1,3.7,3.4,4.709,4.709,0,0,1-1.476,4.927L3.385,57.1l4.4,7.621,4.378-1.639a4.767,4.767,0,0,1,6.076,6.075L16.6,73.537l7.621,4.4,2.946-3.577A4.794,4.794,0,0,1,35.5,76.584l.743,4.74h8.841l.743-4.74a4.8,4.8,0,0,1,8.331-2.222L57.1,77.939l7.621-4.4L63.085,69.16a4.767,4.767,0,0,1,6.076-6.075l4.378,1.639,4.4-7.621-3.577-2.946a4.794,4.794,0,0,1,2.222-8.331ZM40.662,62.1A21.443,21.443,0,1,1,62.105,40.662,21.467,21.467,0,0,1,40.662,62.1Zm0-38.12A16.678,16.678,0,1,0,57.34,40.662,16.7,16.7,0,0,0,40.662,23.984Zm0,28.59A11.913,11.913,0,1,1,52.575,40.662,11.926,11.926,0,0,1,40.662,52.574Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType7);
export default __webpack_public_path__ + "static/media/aioa-icon-type-7.0cf0078cff38d0f4fc95bfc7118abead.svg";
export { ForwardRef as ReactComponent };